import { ProductsControllerFindAll$Params } from '@klubovna/api-client';
import { DeleteProductDto, Product, SetRecipeDto } from '@klubovna/api-client';
import { PaginatedResponse } from '@klubovna/api-client';
import { createAction, props } from '@ngrx/store';

export const ADMIN_PRODUCTS_ID = '[Products admin]';

export const loadProducts = createAction(
  ADMIN_PRODUCTS_ID + ' Load Products',
  props<{ params?: ProductsControllerFindAll$Params }>(),
);

export const loadProductsSuccess = createAction(
  ADMIN_PRODUCTS_ID + ' Load Products Success',
  props<{ response: PaginatedResponse<Product> }>(),
);

export const loadProductsFailure = createAction(
  ADMIN_PRODUCTS_ID + ' Load Products Failure',
  props<{ error: string }>(),
);

export const createProduct = createAction(
  ADMIN_PRODUCTS_ID + ' Create Product',
  props<{ productData: CreateProductData; recipe?: SetRecipeDto; deleteRecipe?: boolean }>(),
);

export const createProductSuccess = createAction(
  ADMIN_PRODUCTS_ID + ' Create Product Success',
  props<{ product: Product }>(),
);

export const createProductFailure = createAction(
  ADMIN_PRODUCTS_ID + ' Create Product Failure',
  props<{ error: string }>(),
);

export const updateProduct = createAction(
  ADMIN_PRODUCTS_ID + ' Update Product',
  props<{ id: string; productData: UpdateProductData; recipe?: SetRecipeDto; deleteRecipe?: boolean }>(),
);

export const updateProductSuccess = createAction(
  ADMIN_PRODUCTS_ID + ' Update Product Success',
  props<{ product: Product }>(),
);

export const updateProductFailure = createAction(
  ADMIN_PRODUCTS_ID + ' Update Product Failure',
  props<{ error: string }>(),
);

export const deleteProduct = createAction(
  ADMIN_PRODUCTS_ID + ' Delete Product',
  props<{ id: string; deletionParams?: DeleteProductDto }>(),
);

export const deleteProductSuccess = createAction(
  ADMIN_PRODUCTS_ID + ' Delete Product Success',
  props<{ id: string }>(),
);

export const deleteProductFailure = createAction(
  ADMIN_PRODUCTS_ID + ' Delete Product Failure',
  props<{ error: string }>(),
);

export interface CreateProductData {
  name: string;
  categoryId: string;
  priceCents: number;
  sortOrder?: number;
  isActive?: boolean;
  rewardId?: string;
  minStockQty?: number;
  volumeMl?: number | null;
  vatRate?: number | null;
  unitPackagingTypeId?: string | null;
  groupPackagingTypeId?: string | null;
}

export interface UpdateProductData {
  name?: string;
  categoryId?: string;
  priceCents?: number;
  sortOrder?: number;
  isActive?: boolean;
  rewardId?: string;
  minStockQty?: number;
  volumeMl?: number | null;
  vatRate?: number | null;
  unitPackagingTypeId?: string | null;
  groupPackagingTypeId?: string | null;
}
